<div class="tv-admin-embed" id="tour-target-admin-flow">
  <nav class="admin-progress" id="tour-target-admin-progress" aria-label="Progreso de recuperación de contraseña">
    <div class="admin-progress-list" role="list">
      <ng-container *ngFor="let s of progressSteps; let i = index">
        <div
          class="admin-progress-item"
          role="listitem"
          [class.is-current]="isStepCurrent(s.key)"
          [class.is-done]="isStepDone(s.key)">
          <span class="admin-progress-icon" [ngClass]="s.tone" aria-hidden="true"><i [class]="s.icon"></i></span>
          <span class="admin-progress-copy">
            <span class="admin-progress-title">{{ s.title }}</span>
            <span class="admin-progress-desc">{{ s.desc }}</span>
          </span>
        </div>
        <span
          *ngIf="i < progressSteps.length - 1"
          class="admin-progress-connector"
          aria-hidden="true"
          [class.is-done]="progressStep > s.key"></span>
      </ng-container>
    </div>
  </nav>

  <div class="reset-flow" [class.reset-flow-wide]="stepActual === 4">
    <app-reset-step-identificacion
      *ngIf="stepActual === 1"
      (next)="nextStep()"></app-reset-step-identificacion>
    <app-reset-step-verificacion
      *ngIf="stepActual === 2"
      (next)="nextStep()"
      (back)="previousStep()"></app-reset-step-verificacion>
    <app-reset-step-codigo
      *ngIf="stepActual === 3"
      (next)="nextStep()"
      (back)="previousStep()"></app-reset-step-codigo>
    <app-reset-step-certificados
      *ngIf="stepActual === 4"
      (next)="nextStep()"
      (back)="previousStep()"
      (cancelar)="onCancelar()"></app-reset-step-certificados>
    <app-reset-step-cambio-contrasena
      *ngIf="stepActual === 5"
      (next)="nextStep()"
      (back)="previousStep()"></app-reset-step-cambio-contrasena>
    <app-reset-step-exito
      *ngIf="stepActual === 6"
      (reiniciar)="resetFlow()"
      (cerrar)="closeAndNavigate()"></app-reset-step-exito>
  </div>
</div>
